(function(){
  	document.addEventListener('DOMContentLoaded', function() {		
		
		document.addEventListener("click", function(event) {
			let $target =  event.target;
			if ( $target.closest('.variant_data') ) {
				$target = $target.closest('.variant_data');
			}
			if ( $target.closest(".clicked_option") ) {
				$target = $target.closest('.clicked_option');
			}
			console.log($target);
			var optionsWrapper = $target.closest(".options.wrapper");
			var optionsContainer = $target.closest('.set-product-details');
			var productContainer = $target.closest('.set-product');
			if (optionsWrapper) {
				if ($target.classList.contains("clicked_option")) {
					var options = optionsWrapper.querySelectorAll("li:not(.clicked_option)");
					for (var i = 0; i < options.length; i++) {
						if(options[i].style.display == 'block') {
							options[i].style.display = 'none';
						} else {
							options[i].style.display = 'block';
						}
					}
				} else if(!$target.classList.contains("sold-out-variant")) {
					if ( ! $target.closest('.variant_data') ) return false;

					var allOptions = optionsWrapper.querySelectorAll("li:not(.clicked_option)");
					for (var i = 0; i < allOptions.length; i++) {
						allOptions[i].classList.remove("selected");
					}
					$target.classList.add("selected");
					optionsWrapper.querySelector(".clicked_option").innerHTML = $target.innerHTML;
					optionsWrapper.querySelector(".clicked_option").classList.add("selected_option");
					if(optionsContainer.querySelector('.product_option_wrapper ul[data-option-position="2"]') != null) {
						optionsContainer.querySelector('.product_option_wrapper ul[data-option-position="2"]').removeAttribute('disabled');
					} else {
						productContainer.querySelector('.add_more_btn').removeAttribute('disabled');
					}
					for (var i = 0; i < allOptions.length; i++) {
						allOptions[i].style.display = "none";
					}
				}
			}

			if ( $target.closest('ul[data-option-position="2"]') && ! $target.classList.contains('clicked_option')) {
				
				$container = $target.closest('.set-product-details');
				console.log('container', $container);
				let block = $target.closest('.spd-container');
				console.log('block', block);
				$(block).next().removeAttr('disabled');
				$data = JSON.parse($($container).find('script[data-product-json]').html());
				addToList($($target), $($container), $data);
			}
			
			//Code For set_product form hide and show
			if ($target.id === "setFormEnable") {
				var setProductForm = document.querySelector(".custom_form_set_product");
				setProductForm.classList.toggle("active");
			}
					
		});
	}, false);
})();

function reindexBlocks() {
  let blocks = document.querySelectorAll('.set-product-details');
  let index = 1;
  blocks.forEach( elem => {
    elem.setAttribute('data-line', index);
    index++;
  });

  let blocksReady = document.querySelectorAll('.set_product_wrapper');
  let i = 1;
  blocksReady.forEach( elem => {
    elem.setAttribute('data-line', i);
    i++;
  });
}

$(document).on('click', '.add_more_btn', function(){
	var $this = $(this),
	$html = $this.prev().html();
	$this.after('<div class="spd-container">' + $html + '</div><button class="add_more_btn" disabled="">+ אני רוצה עוד מהמוצר הזה</button>');
	var $newproduct = $this.next();
	$newproduct.find('.product_option_wrapper').each(function(){
		if ( $(this).hasClass('variantsList') ) $(this).remove();
        let originalTitle = $(this).find('.title_bundle').attr('data-original-title')
        $(this).find('.title_bundle').text(originalTitle);
		var $this = $(this),
		$name = $this.data('name');
		$this.find('.clicked_option').removeClass('.selected_option').text($name);
		$this.find('.variant_data.selected').removeClass('selected');
	});
	var $dataline = parseInt($newproduct.find('.set-product-details').data('line')) + 1;
	$newproduct.find('.set-product-details').attr('data-line', $dataline);
    reindexBlocks();
	return false;
});

$(document).ready(function(){
	console.log('custom.js');

  $('.set-product-details').each(function(){
    var $container = $(this),
		$data = JSON.parse($container.find('script[data-product-json]').html());
		$variants = $data.variants;
		$container.find('.options.wrapper[data-option-position="1"] .list_option_inner li').each(function(){
			var $this = $(this),
			$val = $this.data('value');
			for(var i = 0; i < $variants.length; i++) {
				if($variants[i].option1 == $val) {
					var $available = $variants[i].available;
					if($available == false) {
						$container.find(`li[data-value='${$val}']`).addClass('sold-out-variant');
					}
				}
			}
		});
  });
});

$(document).on('click', 'ul[data-option-position="1"] .variant_data', function(){
	var $this = $(this);
	$container = $this.closest('.set-product-details');
	$data = JSON.parse($(this).find('script[data-product-json]').html());
	console.log($data);
	let $variants = $data.variants;
  
    if ( $variants.length < 2 ) {
      $this.closest('.spd-container').next().removeAttr('disabled');
      console.log($this);
      let variantId = $this.attr('data-variant-id');
      addToListSingle($this, $container, $data, variantId);
      return false;
    }
  
	let variantsList = '';
	let firstAvailableVar = '';
	for (var key in $variants) {
		let soldOut = $variants[key].available ? '' : 'sold-out-variant';
		if ( firstAvailableVar === '' && $variants[key].available ) {
			firstAvailableVar = `
				<li class="clicked_option">
				נא לבצע בחירה
				</li>
				`;
		}
		let titleVariant = $variants[key].title == 'Default Title' ? $data.title : $variants[key].title;
		console.log($variants[key]);
		variantsList += `
		<li data-variant-id="${$variants[key].id}" data-value="${titleVariant}" class="variant_data ${soldOut}" style="display: none;">`;
		variantsList +=	`${titleVariant}`;
		variantsList +=	`</li>`;
	}
	let sizeSelect = `
	<div class="product_option_wrapper variantsList" data-name="בחירת מידת סדין">
		<ul class="list-unstyled options wrapper  size" data-option-name="בחירת מידת סדין" data-option-position="2" name="option-בחירת-מידת-סדין">
			${firstAvailableVar}
			<svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-arrow-left  icon--direction-aware" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="#000" stroke-linecap="square"></path></svg>
			<ul class="list_option_inner">
				${variantsList}
			</ul>
		</ul>
	</div>
	`;

	if ( $(this).closest('.set-product-details').find('.product_option_wrapper.variantsList').length > 0 ) {
		$(this).closest('.set-product-details').find('.product_option_wrapper.variantsList').remove();
	}
	$(this).closest('.set-product-details').find('.product_option_wrapper').after(sizeSelect);

	$check = $container.find('ul[data-option-position="2"] .clicked_option.selected_option');
	if($this.closest('ul[data-option-position="1"]').length > 0 && $check.length > 0) {
		$option1 = $.trim($container.find('ul[data-option-position="1"] .variant_data.selected').data('value'));
		$container.find('ul[data-option-position="2"] li').removeClass('sold-out-variant');
		for(var i = 0; i < $variants.length; i++) {
			if($variants[i].option1 == $option1) {
				var $available = $variants[i].available;
				if($available == false) {
					$option2 = $variants[i].option2;
					$container.find(`li[data-value='${$option2}']`).addClass('sold-out-variant');
				}
			}
		}
	}
});

function addToListSingle($this, $container, $data, variantID ) {
	$dataline = parseInt($container.attr('data-line'));
	$option1 = $.trim($container.find('ul[data-option-position="1"] .variant_data.selected').data('value'));
  	$option2 = null;
	$variants = $data.variants;
	$oldId = $container.find('input[name="id"]').val();
	$container.find('input[name="id"]').val(variantID);
    console.log($container.find('input[name="id"]'));
	let variantObj = $variants.filter(function(obj) {
		return obj.id == variantID;
	});

	console.log(22, variantObj[0]);
	let $var = variantObj[0];
	$id = $var.id;
	$container.find('input[name="id"]').val($id);
	var $available = $var.available;
	if($available == false) {
		return false;
	} else {
		$this.closest('.spd-container').find('.sold-out-message').hide();
	}
	var $nprice = $var.price;
	$ncomprice = $var.compare_at_price;
	if($var.featured_image != null) {
		var $src = $var.featured_image.src;
	} else {
		var $src = $data.featured_image;
	}

	var $url = '/products/' + $data.handle,
	$title = $data.title,
	$price = $var.price;
	$compare_at_price = $var.compare_at_price;

	if($option2 == null) {
		$option2 = '';
	}

	if(typeof $compare_at_price == "undefined" || $compare_at_price == null || $compare_at_price == 0 ) {
		$compare_at_price = '';
		$('.saved_price').hide();
	} else {
		$compare_at_price = formatMoney($compare_at_price, format="");
		$('.saved_price').show();
	}

	$price = formatMoney($price, format="");
	$html = '<div data-price="' + $nprice + '" data-compare-price="' + $ncomprice + '" class="set_product_wrapper grid-4 grid-mobile-4" data-id="' + $id + '" data-line="' + $dataline + '"><div class="product_image_wrapper"><img src="' + $src + '" height="100%" width="100%" loading="lazy"><button class="remove_btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20.69 20.16" style="enable-background:new 0 0 20.69 20.16;" xml:space="preserve"><style type="text/css">.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}.st1{fill:none;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}</style><g><g><line class="st0" x1="6.34" y1="6.08" x2="14.34" y2="14.08"/><line class="st0" x1="14.34" y1="6.08" x2="6.34" y2="14.08"/></g><circle class="st0" cx="10.34" cy="10.08" r="8.95"/></g></svg></button></div><a href="' + $url + '" class="product__title">' + $title + '</a><p class="added_variant" data-variant="' + $option1 + '">' + $option1 + '</p><p class="added_variant">' + $option2 + '</p><price-list class="price-list "><sale-price class="text-subdued"><span class="st-only">' + $price + '</span><dt class="dt-only">' + $compare_at_price + '</dt></sale-price></price-list></div>';
	if($('.set_product_wrapper[data-id="' + $oldId + '"][data-line="' + $dataline + '"]').length) {
		$('.set_product_wrapper[data-id="' + $oldId + '"][data-line="' + $dataline + '"]').remove();
	}
	if(typeof $title == "undefined") {
		$html = "";
	}
	$('.added_product').append($html);

    let parentElement = document.querySelector(`.set-product-details[data-line="${$dataline}"] .product_option_wrapper`);
    let h3 = parentElement.querySelector('h3');
    h3.textContent = $dataline + '. ' + $data.title;

	var $length = $('.added_product .set_product_wrapper').length;
	if($length > 0) {
		$('.add-set-cart').removeClass('disabled');
	} else {
		$('.add-set-cart').addClass('disabled');
	}
	var $tprice = 0;
	var $comprice = 0;
	for(var i = 1; i <= $('.added_product .set_product_wrapper').length; i++) {
		$tprice = $tprice + $('.added_product .set_product_wrapper:nth-of-type(' + i + ')').data('price');
		let newComparePrice = $('.added_product .set_product_wrapper:nth-of-type(' + i + ')').data('compare-price');
		if(!newComparePrice) {
			newComparePrice = $('.added_product .set_product_wrapper:nth-of-type(' + i + ')').data('price');
		}
		$comprice = $comprice + newComparePrice;
	}
	$('.priceTotal').text(formatMoney($tprice, format = ""));

	$sprice = $comprice - $tprice;
	if($('.set_product_wrapper[data-id="' + $oldId + '"][data-line="' + $dataline + '"]').length < 1) {
		if($sprice > 0) {
			$('.priceSale').data('price', $sprice).text(formatMoney($sprice, format = ""));
		} else {
			$('.priceSale').data('price', '0').text('0');
		}
	}
}

function addToList($this, $container, $data) {
	$dataline = parseInt($container.attr('data-line'));
	$option1 = $.trim($container.find('ul[data-option-position="1"] .variant_data.selected').data('value'));
	let variantID = 0;
	if($container.find('ul[data-option-position="2"] .selected_option').length) {
		$option2 = $.trim($container.find('ul[data-option-position="2"]  .variant_data.selected').data('value'));
		variantID = $.trim($container.find('ul[data-option-position="2"]  .variant_data.selected').data('variant-id'));
	} else {
		$option2 = null;
	}
	$variants = $data.variants;
	$oldId = $container.find('input[name="id"]').val();
	$container.find('input[name="id"]').val(variantID);
    console.log($container.find('input[name="id"]'));
	let variantObj = $variants.filter(function(obj) {
		return obj.id == variantID;
	});

	console.log(22, variantObj[0]);
	let $var = variantObj[0];
	$id = $var.id;
	$container.find('input[name="id"]').val($id);
	var $available = $var.available;
	if($available == false) {
		return false;
	} else {
		$this.closest('.spd-container').find('.sold-out-message').hide();
	}
	var $nprice = $var.price;
	$ncomprice = $var.compare_at_price;
	if($var.featured_image != null) {
		var $src = $var.featured_image.src;
	} else {
		var $src = $data.featured_image;
	}

	var $url = '/products/' + $data.handle,
	$title = $data.title,
	$price = $var.price;
	$compare_at_price = $var.compare_at_price;

	if($option2 == null) {
		$option2 = '';
	}

	if(typeof $compare_at_price == "undefined" || $compare_at_price == null || $compare_at_price == 0 ) {
		$compare_at_price = '';
		$('.saved_price').hide();
	} else {
		$compare_at_price = formatMoney($compare_at_price, format="");
		$('.saved_price').show();
	}

	$price = formatMoney($price, format="");
	$html = '<div data-price="' + $nprice + '" data-compare-price="' + $ncomprice + '" class="set_product_wrapper grid-4 grid-mobile-4" data-id="' + $id + '" data-line="' + $dataline + '"><div class="product_image_wrapper"><img src="' + $src + '" height="100%" width="100%" loading="lazy"><button class="remove_btn"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20.69 20.16" style="enable-background:new 0 0 20.69 20.16;" xml:space="preserve"><style type="text/css">.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}.st1{fill:none;stroke:#000000;stroke-linecap:round;stroke-miterlimit:10;}</style><g><g><line class="st0" x1="6.34" y1="6.08" x2="14.34" y2="14.08"/><line class="st0" x1="14.34" y1="6.08" x2="6.34" y2="14.08"/></g><circle class="st0" cx="10.34" cy="10.08" r="8.95"/></g></svg></button></div><a href="' + $url + '" class="product__title">' + $title + '</a><p class="added_variant" data-variant="' + $option1 + '">' + $option1 + '</p><p class="added_variant">' + $option2 + '</p><price-list class="price-list "><sale-price class="text-subdued"><span class="st-only">' + $price + '</span><dt class="dt-only">' + $compare_at_price + '</dt></sale-price></price-list></div>';
	if($('.set_product_wrapper[data-id="' + $oldId + '"][data-line="' + $dataline + '"]').length) {
		$('.set_product_wrapper[data-id="' + $oldId + '"][data-line="' + $dataline + '"]').remove();
	}
	if(typeof $title == "undefined") {
		$html = "";
	}
	$('.added_product').append($html);

    let parentElement = document.querySelector(`.set-product-details[data-line="${$dataline}"] .product_option_wrapper`);
    let h3 = parentElement.querySelector('h3');
    h3.textContent = $dataline + '. ' + $data.title;

	var $length = $('.added_product .set_product_wrapper').length;
	if($length > 0) {
		$('.add-set-cart').removeClass('disabled');
	} else {
		$('.add-set-cart').addClass('disabled');
	}
	var $tprice = 0;
	var $comprice = 0;
	for(var i = 1; i <= $('.added_product .set_product_wrapper').length; i++) {
		$tprice = $tprice + $('.added_product .set_product_wrapper:nth-of-type(' + i + ')').data('price');
		let newComparePrice = $('.added_product .set_product_wrapper:nth-of-type(' + i + ')').data('compare-price');
		if(!newComparePrice) {
			newComparePrice = $('.added_product .set_product_wrapper:nth-of-type(' + i + ')').data('price');
		}
		$comprice = $comprice + newComparePrice;
	}
	$('.priceTotal').text(formatMoney($tprice, format = ""));

	$sprice = $comprice - $tprice;
	if($('.set_product_wrapper[data-id="' + $oldId + '"][data-line="' + $dataline + '"]').length < 1) {
		if($sprice > 0) {
			$('.priceSale').data('price', $sprice).text(formatMoney($sprice, format = ""));
		} else {
			$('.priceSale').data('price', '0').text('0');
		}
	}
}

function formatMoney(cents, format = "") {
	if (typeof cents === "string") {
		cents = cents.replace(".", "");
	}
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
	function defaultTo(value2, defaultValue) {
		return value2 == null || value2 !== value2 ? defaultValue : value2;
	}
	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultTo(precision, 2);
		thousands = defaultTo(thousands, ",");
		decimal = defaultTo(decimal, ".");
		if (isNaN(number) || number == null) {
			return 0;
		}
		number = (number / 100).toFixed(precision);
		let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
		return dollarsAmount + centsAmount;
	}
	let value = "";
	switch (formatString.match(placeholderRegex)[1]) {
		case "amount":
			value = formatWithDelimiters(cents, 2);
			break;
		case "amount_no_decimals":
			value = formatWithDelimiters(cents, 0);
			break;
		case "amount_with_space_separator":
			value = formatWithDelimiters(cents, 2, " ", ".");
			break;
		case "amount_with_comma_separator":
			value = formatWithDelimiters(cents, 2, ".", ",");
			break;
		case "amount_with_apostrophe_separator":
			value = formatWithDelimiters(cents, 2, "'", ".");
			break;
		case "amount_no_decimals_with_comma_separator":
			value = formatWithDelimiters(cents, 0, ".", ",");
			break;
		case "amount_no_decimals_with_space_separator":
			value = formatWithDelimiters(cents, 0, " ");
			break;
		case "amount_no_decimals_with_apostrophe_separator":
			value = formatWithDelimiters(cents, 0, "'");
			break;
	}
	if (formatString.indexOf("with_comma_separator") !== -1) {
		return formatString.replace(placeholderRegex, value);
	} else {
		return formatString.replace(placeholderRegex, value);
	}
}

$(document).on('click', '.remove_btn', function(){
	var $item = $(this).closest('.set_product_wrapper'),
	$id = $item.data('id'),
	$line = $item.data('line'),
	$connectTo = $('.set-product-details[data-line="' + $line + '"]'),
	$connectedItem = $connectTo.closest('.set-product-details');
	$connectedItem.find('.product_option_wrapper').each(function(){
		var $this = $(this),
		$name = $this.data('name');
		$this.find('.clicked_option').removeClass('.selected_option').text($name);
		$this.find('.variant_data.selected').removeClass('selected');
	});
	$connectedItem.find('.clicked_option.selected_option').removeClass('selected_option');
	$item.remove();
	var $length = $('.added_product .set_product_wrapper').length;
	var $tprice = 0;
	var $comprice = 0;
	if($length > 0) {
		$('.add-set-cart').removeClass('disabled');
		for(var i = 1; i <= $('.added_product .set_product_wrapper').length; i++) {
			$tprice = $tprice + $('.added_product .set_product_wrapper:nth-of-type(' + i + ')').data('price');
			let newComparePrice = $('.added_product .set_product_wrapper:nth-of-type(' + i + ')').data('compare-price');
			if(!newComparePrice) {
				newComparePrice = $('.added_product .set_product_wrapper:nth-of-type(' + i + ')').data('price');
			}
			$comprice = $comprice + newComparePrice;
		}
	} else {
		$('.add-set-cart').addClass('disabled');
	}
	$('.priceTotal').text(formatMoney($tprice, format = ""));

	$sprice = $comprice - $tprice;
	if($sprice > 0) {
		$('.priceSale').data('price', $sprice).text(formatMoney($sprice, format = ""));
		$('.saved_price').show();
	} else {
		$('.priceSale').data('price', '0').text('0');
		$('.saved_price').hide();
	}
});

// ==========================================
// ADD TO CART — עם שמירת ברכה מתוקנת
// ==========================================
$(document).on('click', '.add-set-cart:not(.disabled)', async function(){
	var $data = [];
	var $productTitle = $('.product-info__block-item .product-title').text();
	let $bundleWrapper = $(this).closest('.product-info__block-list.set');
	let bundleProductId = $bundleWrapper.data("bundle-id");
	let bundleProductIcon = $bundleWrapper.data("bundle-icon");
	let $sender = $('#senderName');
	let $receiver = $('#receiverName');
	let $message = $('#message');
	let $greetingCard = $('[data-greeting-card-input]');
	let $senderLabel = $sender.data("label");
	let $receiverLabel = $receiver.data("label");
	let $messageLabel = $message.data("label");
	let $greetingCardLabel = $greetingCard.data("label");
	let $greetingoptionsWrapper = $('[data-greeting-options-wrapper]');
	let $caseTypeLabel = $greetingoptionsWrapper.data("label");
	var drawer = document.querySelector('#cart-drawer');

	$('.added_product .set_product_wrapper').each(function(){
		var $this = $(this),
		$variant = $this.data('id');
		$data.push({
			"quantity": 1,
			"id": $variant,
			"properties": {
				"_bundle_main_title": $productTitle,
				"_bundle_product": "yes",
				"_bundle_id": bundleProductId,
				"_bundle_icon": bundleProductIcon
			}
		});
	});

	if($greetingCard.is(':checked')) {
		var $senderValue = $sender.val().trim(),
		$receiverValue = $receiver.val().trim(),
		$messageValue = $message.val().trim();
		if(!$senderValue) {
			$sender.closest('div').find('p').show();
			return false;
		}
		if(!$receiverValue) {
			$receiver.closest('div').find('p').show();
			return false;
		}
		if(!$messageValue) {
			$message.closest('div').find('p').show();
			return false;
		}
	}

	document.dispatchEvent(new CustomEvent("theme:loading:start"));

	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		dataType: 'json',
		data: { items: $data },
		success: async function(data) {
			document.dispatchEvent(new CustomEvent("theme:loading:end"));

			// ── שמירת הברכה תמיד, לפני פתיחת הדרואר ──
			let greetingCardNotes = "";
			if ($greetingCard.is(':checked')) {
				let greetingCardValue = $greetingCard.val();
				let senderValue = $sender.val().trim();
				let receiverValue = $receiver.val().trim();
				let messageValue = $message.val().trim();
				let caseType = $greetingoptionsWrapper.find('input[name="case_type"]:checked').val() || "";

				greetingCardNotes = `[ADDITIONAL_NOTES]${$greetingCardLabel}: ${greetingCardValue} | ${$senderLabel}: ${senderValue} | ${$receiverLabel}: ${receiverValue} | ${$messageLabel}: ${messageValue} | ${$caseTypeLabel}: ${caseType}[/ADDITIONAL_NOTES]`;

				await $.ajax({
					type: 'POST',
					url: '/cart/update.js',
					dataType: 'json',
					data: { note: greetingCardNotes }
				});

				// ── עדכון שדות בדרואר ──
				setTimeout(function () {
					$('cart-note input[name="senderName"]').val(senderValue);
					$('cart-note input[name="receiverName"]').val(receiverValue);
					$('cart-note .message-input textarea').val(messageValue);
					$('cart-note .cart-note-input textarea').val(greetingCardNotes);
					$("[data-need-greeting-card]").prop("checked", true);
					$('[data-cart-note-wrapper] .greeting_options input[value="' + caseType + '"]').prop('checked', true).trigger('change');
				}, 500);
			}

			// ── פתיחת הדרואר — Planet או ברירת מחדל ──
			if (window.PlanetDataset && window.PlanetDataset.SmartCart &&
				window.PlanetDataset.SmartCart.methods &&
				window.PlanetDataset.SmartCart.methods.openDrawer) {

				window.PlanetDataset.SmartCart.methods.openDrawer(true);

			} else {
				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
				setTimeout(function () {
					drawer.show();
				}, 500);
			}
		}
	});
});

$(document).on('click', 'body', function(e){
	if(!$(e.target).closest('.options.wrapper').length > 0) {
		$('.list_option_inner li').hide();
	}
});

$(document).on('click', '[data-save-note]', function(){
	var $cartNote = $(this).closest('cart-note');
	let $sender = $cartNote.find('input[name="senderName"]');
	let $receiver = $cartNote.find('input[name="receiverName"]');
	let $message = $cartNote.find('textarea');
	let $greetingCard = $('[data-need-greeting-card]');
	let $senderLabel = $sender.data("label");
	let $receiverLabel = $receiver.data("label");
	let $messageLabel = $message.data("label");
	let $greetingCardLabel = $greetingCard.data("label");
	let $greetingoptionsWrapper = $cartNote.find('.greeting_options');
	let $caseTypeLabel = $greetingoptionsWrapper.data("label");
	let $senderValue = $sender.val().trim();
	let $receiverValue = $receiver.val().trim();
	let $messageValue = $message.val().trim();
	let $greetingCardValue = $greetingCard.val();
	let $caseType = $greetingoptionsWrapper.find('input[name="case_type"]:checked').val() || "";
	let greetingCardNotes = "";

	if ($cartNote.find('[name="note"]').length) {
		greetingCardNotes = $cartNote.find('[name="note"]').val();
	}

	if ($greetingCard.is(':checked')) {
		if (!$senderValue) {
			$sender.closest('.fieldset-note-row').find('p.error').show();
			return false;
		}
		if (!$receiverValue) {
			$receiver.closest('.fieldset-note-row').find('p.error').show();
			return false;
		}
		if (!$messageValue) {
			$message.closest('.fieldset-note-row').find('p.error').show();
			return false;
		}
		greetingCardNotes = `[ADDITIONAL_NOTES]${$greetingCardLabel}: ${$greetingCardValue} | ${$senderLabel}: ${$senderValue} | ${$receiverLabel}: ${$receiverValue} | ${$messageLabel}: ${$messageValue} | ${$caseTypeLabel}: ${$caseType}[/ADDITIONAL_NOTES]`;
	}

	$.ajax({
		type: 'POST',
		url: '/cart/update.js',
		dataType: 'json',
		data: { note: greetingCardNotes },
		success: function(data) {
			$('.fieldset-note-row').find(".error").hide();
			$('cart-note .cart-note-input textarea').val(greetingCardNotes);
		}
	});
});

$(document).on('mouseover', '.custom-color-options-list a', function(){
	var $this = $(this),
	$color = $this.data('color');
	console.log($color);
	$('.selected-custom-color').text($color);
});

$(window).on('scroll', function(){
	if($('.spg-dots').length) {
		$('.spg-item').each(function(){
			var $this = $(this),
			$offset = $this.offset().top,
			$threshold = $(window).outerHeight(),
			$scrollAmount = $(window).scrollTop() + $threshold;
			if($scrollAmount >= $offset) {
				$('.spg-dot-item').removeClass('active-dot');
				$id = $this.attr('id');
				$('.spg-dot-item[href="#' + $id + '"').addClass('active-dot');
			}
		});
	}
});